import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR,
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_SUCCESS,
  UPDATE_SETTINGS_ERROR,
} from "./actionTypes";

export const getSettings = () => {
  return {
    type: GET_SETTINGS,
  };
};

export const getSettingsSuccess = (settings) => {
  return {
    type: GET_SETTINGS_SUCCESS,
    payload: settings,
  };
};

export const getSettingsFailure = (error) => {
  return {
    type: GET_SETTINGS_ERROR,
    payload: error,
  };
};

export const updateSettings = (settings) => {
  return {
    type: UPDATE_SETTINGS,
    payload: { settings },
  };
};

export const updateSettingsSuccess = (settings) => {
  return {
    type: UPDATE_SETTINGS_SUCCESS,
    payload: settings,
  };
};

export const updateSettingsFailure = (error) => {
  return {
    type: UPDATE_SETTINGS_ERROR,
    payload: error,
  };
};
